(ns app.subscription.suggest-upgrade
  "Shared logic to determine if a user's auto top-up quantity is sufficient
   to cover obligatory services for a billing period, taking price-adjustments
   into account. Used by both server-side query and client-side interactive
   plan change validation.")

(defn billing-interval-days
  [interval]
  (case (keyword interval)
    :year 365
    :month 31
    31))

(defn calc-obligatory-total
  "Calculates the minimum cost for obligatory services (instagram-connection +
   storage-flat-fee) over one billing period, applying discounts.

   Expects a map with:
     :billing-interval - keyword or string (:month, :year, \"month\", \"year\")
     :instagram-connections-count - number of connected accounts
     :services - map of service-id to service map (must contain :price)
     :discounts - map of service-id to discount (0.0–1.0, nil treated as 0)"
  [{:keys [billing-interval instagram-connections-count services discounts]}]
  (let [days (billing-interval-days billing-interval)
        calc-service (fn [service-id units]
                       (let [price (:price (get services service-id))
                             discount (or (get discounts service-id) 0)
                             discounted-price (* price (- 1.0 discount))]
                         (* days discounted-price units)))]
    (+ (calc-service :storage-flat-fee 1)
       (calc-service :instagram-connection instagram-connections-count))))

(defn suggest-upgrade
  "Calculates if a selected plan of `quantity` and `billing-interval` is sufficient
   to run `instagram-connections-count` of connections, taking price-adjustments
   into account.

   Expects a map with all keys from `calc-obligatory-total` plus:
     :quantity - current (or selected) top-up amount"
  [{:keys [quantity] :as w}]
  (let [minimum-top-up (int (Math/ceil (calc-obligatory-total w)))]
    {:minimum-top-up minimum-top-up
     :current-top-up quantity
     :upgrade? (< quantity minimum-top-up)}))
